export const ORD_CONTENT_ORIGIN = "https://api.1sat.app/content";
export const ORD_IMAGE_ORIGIN = "https://api.1sat.app/1sat/ordfs/image";

const OUTPOINT_RE = /^\/([a-fA-F0-9]{64})[_.](\d+)$/;
const OUTPOINT_IN_PATH_RE = /(?:^|\/)([a-fA-F0-9]{64})[_.](\d+)(?:\?|$)/;

const ORDFS_HOSTS = new Set([
	"ordfs.network",
	"ordfs.gorillapool.io",
	"ordfs.1sat.app",
]);

export type OrdImageFit = "limit" | "fit" | "fill" | "pad" | "scale";

export interface OrdImageOptions {
	w?: number;
	h?: number;
	fit?: OrdImageFit;
	g?:
		| "center"
		| "north"
		| "south"
		| "east"
		| "west"
		| "northeast"
		| "northwest"
		| "southeast"
		| "southwest";
	f?: "auto" | "jpeg" | "png" | "webp" | "avif";
	q?: number;
}

export function contentUrlForOutpoint(outpoint: string): string {
	const normalized = outpoint.replace(".", "_");
	return `${ORD_CONTENT_ORIGIN}/${normalized}`;
}

export function ordfsImageUrl(
	outpoint: string,
	options: OrdImageOptions
): string {
	const params = new URLSearchParams();
	for (const [key, value] of Object.entries(options)) {
		if (value !== undefined) {
			params.set(key, String(value));
		}
	}
	const query = params.toString();
	const path = `${ORD_IMAGE_ORIGIN}/${outpoint.replace(".", "_")}`;
	return query ? `${path}?${query}` : path;
}

export function extractInscriptionOutpoint(value: string): string | null {
	const match = OUTPOINT_IN_PATH_RE.exec(value);
	if (!match) {
		return null;
	}
	return `${match[1]}_${match[2]}`;
}

function isOneSatContentPath(pathname: string): boolean {
	return (
		pathname.startsWith("/content/") ||
		pathname.startsWith("/1sat/ordfs/image/")
	);
}

export function resolveOrdContentUrl(url: URL): URL {
	if (url.hostname === "api.1sat.app" && isOneSatContentPath(url.pathname)) {
		const outpoint = extractInscriptionOutpoint(url.pathname);
		if (outpoint) {
			return new URL(contentUrlForOutpoint(outpoint));
		}
		return url;
	}

	if (!ORDFS_HOSTS.has(url.hostname)) {
		return url;
	}

	const match = OUTPOINT_RE.exec(url.pathname);
	if (!match) {
		return url;
	}

	return new URL(contentUrlForOutpoint(`${match[1]}_${match[2]}`));
}
